export default theme => ({
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    flex: '4 1 0',
    display: 'flex',
    margin: theme.spacing(8),
  },
  image: {
    flex: '6 1 0',
    width: '100%',
  },
  asideBlock: {
    position: 'relative',
    display: 'flex',
    padding: theme.spacing(8),
    backgroundColor: theme.palette.green.main,
  },
  asideText: {
    flex: '3 1 0',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.green.main,
  },
  autor: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),
  },
  desc: {
    display: 'flex',
    '& > *': {
      width: '100%',
      // flex: '1 1 0',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    '& p': {
      padding: theme.spacing(8, 12),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(4),
      },
      '&:first-child': {
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          paddingTop: theme.spacing(4),
          paddingBottom: theme.spacing(2),
          paddingRight: theme.spacing(4),
        },
      },
      '&:last-child': {
        paddingLeft: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(4),
          paddingLeft: theme.spacing(4),
        },
      },
    },
  },
});
